import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { ChannelsInfoResponse } from '../../model/app-state/types.tsx';
import type { State } from '../../model/types.tsx';
import { getChannelsInfo } from '../../services/get-channels-info/index.tsx';
import {
	setChannelsInfo,
	fetchChannelsInfoFailure,
	startFetchingChannelsInfo,
	FETCH_CHANNELS_INFO,
	type Action,
} from '../../state/actions/app-state/index.tsx';
import { getProjectId } from '../../state/selector/app-props/index.tsx';
import { isLoading } from '../../state/selector/app-state/index.tsx';

export const ERROR = 'servicedesk.channels-jsd.get-channels-data';

const fetchChannelsInfoEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_CHANNELS_INFO).switchMap(() => {
		const state = store.getState();
		const projectId = getProjectId(state);

		const fetchChannelsInfo$ = Observable.fromPromise(getChannelsInfo(projectId))
			.filter(() => !isLoading(state))
			.map((channelChannelsInfo: ChannelsInfoResponse) => setChannelsInfo(channelChannelsInfo))
			.catch((error) => {
				log.safeErrorWithoutCustomerData(ERROR, error.message, error);
				return Observable.of(fetchChannelsInfoFailure());
			});

		return Observable.concat(Observable.of(startFetchingChannelsInfo()), fetchChannelsInfo$);
	});

export default fetchChannelsInfoEpic;
